import { render, staticRenderFns } from "./lossChart.vue?vue&type=template&id=2f90d241&"
import script from "./lossChart.vue?vue&type=script&lang=js&"
export * from "./lossChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f90d241')) {
      api.createRecord('2f90d241', component.options)
    } else {
      api.reload('2f90d241', component.options)
    }
    module.hot.accept("./lossChart.vue?vue&type=template&id=2f90d241&", function () {
      api.rerender('2f90d241', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/customerService/attractManage/analyticStatistics/attractLossAnalysis/lossChart.vue"
export default component.exports